
import Vue from 'vue';
import ContactForm from './ContactForm.vue';
export default Vue.extend({
  name: 'Contact',
  components: {
    ContactForm,
  },
});
